export function normalizeClientDisplayName(value) {
  if (typeof value !== "string") return "";
  return value.split(/- SELF:/i)[0].trim();
}
